import { PDFViewer, Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer'
import _ from 'lodash'

// components
import Header from './components/Header'
import Table from './components/Table'
import Footer from './components/Footer'

// styles
import './PDF.css'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    fontSize: 11,
    flexDirection: "column",
    position: 'relative'
  },
  innerPage: {
    position: 'relative'
  },
  footer: {
    position: 'absolute',
    bottom: 0
  }
})

const PDF = props => {
  const paginateLogs = _.chunk(props.location.state.logs, 28)

  return (
    <PDFViewer className='pdf-output'>
      <Document
        title={
          props.location.state.month ? `Device Consumption for ${props.location.state.month}`
            : props.location.state.date ? `Device Consumpton from ${props.location.state.date.start} to ${props.location.state.date.end}` : null
        }
        author='Rehability'
      >
        <Page size="A4" style={styles.page}>
          {paginateLogs.length > 0 && paginateLogs.map((data, i) => (
            <View style={styles.innerPage} key={i}>
              <Header
                data={{
                  month: props.location.state.month,
                  start: props.location.state.date.start,
                  end: props.location.state.date.end
                }}
              />
              <Table
                data={ data }
                page={i + 1}
              />
              <Footer
                page={i + 1}
                pages={paginateLogs.length}
              />
            </View>
          ))}
          {paginateLogs.length === 0 && (
            <View style={styles.innerPage} key='no logs'>
              <Header
                data={{
                  month: props.location.state.month,
                  start: props.location.state.date.start,
                  end: props.location.state.date.end
                }}
              />
              <Table
                data={ props.location.state.logs }
                page={1}
              />
              <Footer
                page={1}
                pages={1}
              />
            </View>
          )}
        </Page>
      </Document>
    </PDFViewer>
  )
}

export default PDF
